import events from '../../../../../events.js'

const {
  ACCESS_TO_AD_INSERTION_CLICKED,
  ACCESS_TO_INSTANT_OFFER_CLICKED,
  AD_FAVORITED,
  AD_IMPRESSIONS_COLLECTED,
  AD_INSERTED_ERROR,
  AD_INSERTED,
  AD_INSERTION_BUTTON_CLICKED,
  AD_INSERTION_FIELD_AUTOCOMPLETED,
  AD_INSERTION_IO_CAR_DETAILS_SUCCESS,
  AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED,
  AD_INSERTION_IO_DATE_CONFIRMED,
  AD_INSERTION_IO_DATE_SELECTED,
  AD_INSERTION_IO_DEALER_SELECTED,
  AD_INSERTION_IO_DEALERS_AND_DATES_VIEWED,
  AD_INSERTION_IO_HOUR_SELECTED,
  AD_INSERTION_IO_NO_OFFER_AVAILABLE,
  AD_INSERTION_IO_VIEWED,
  AD_INSERTION_VIEWED,
  AD_MODIFIED,
  AD_SHARED,
  AI_SEARCH_USED,
  ALERT_CREATED,
  APP_DOWNLOAD_BUTTON_CLICKED,
  APPRAISAL_REQUESTED,
  APPRAISAL_SELECT_DEALER_CONFIRMED,
  DETAIL_NAVBAR_CLICKED,
  DETAIL_VIEWED,
  FILTER_ADDED,
  FILTERS_RESTART_CLICKED,
  HOME_IO_BUTTON_CLICKED,
  INSTANT_OFFER_FORM_VIEWED,
  INSTANT_OFFER_NEXT_CONFIRMED,
  LANDING_IO_DATE_CONFIRMED,
  LANDING_IO_NEXT_CONFIRMED,
  LANDING_IO_VIEWED,
  LAST_DETAILS_SEEN,
  LEAD_ENRICHED,
  LEAD_ERROR,
  LEAD_TRIGGERED,
  LIST_VIEWED,
  MAP_CLICKED,
  LIST_NEWS_SAVED_CLICKED,
  LIST_NEWS_SAVED_VIEWED,
  NEWS_DETAIL_VIEWED,
  PHONE_VIEWED,
  RESERVATION_DRAWER_VIEWED,
  RESERVATION_MORE_INFORMATION_CLICKED,
  RESERVATION_PAYMENT_VIEWED,
  RESERVATION_START_CLICKED,
  RESERVATION_SUCCESS,
  RECOMMENDED_ADS_FALLBACK,
  SEND_MESSAGE_BUTTON_CLICKED,
  SIGNED_IN_ERROR,
  SIGNED_UP_ERROR,
  WEBSITE_CLICKED
} = events

const eventVersions = {
  [ACCESS_TO_AD_INSERTION_CLICKED]: 2,
  [ACCESS_TO_INSTANT_OFFER_CLICKED]: 2,
  [AD_FAVORITED]: 8,
  [AD_IMPRESSIONS_COLLECTED]: 6,
  [AD_INSERTED_ERROR]: 2,
  [AD_INSERTED]: 10,
  [AD_INSERTION_BUTTON_CLICKED]: 2,
  [AD_INSERTION_FIELD_AUTOCOMPLETED]: 2,
  [AD_INSERTION_IO_CAR_DETAILS_SUCCESS]: 1,
  [AD_INSERTION_IO_CONFIRMATION_FAQ_EXPANDED]: 2,
  [AD_INSERTION_IO_DATE_CONFIRMED]: 6,
  [AD_INSERTION_IO_DATE_SELECTED]: 2,
  [AD_INSERTION_IO_DEALER_SELECTED]: 3,
  [AD_INSERTION_IO_DEALERS_AND_DATES_VIEWED]: 2,
  [AD_INSERTION_IO_HOUR_SELECTED]: 2,
  [AD_INSERTION_IO_NO_OFFER_AVAILABLE]: 2,
  [AD_INSERTION_IO_VIEWED]: 6,
  [AD_INSERTION_VIEWED]: 3,
  [AD_MODIFIED]: 2,
  [AD_SHARED]: 7,
  [AI_SEARCH_USED]: 2,
  [ALERT_CREATED]: 4,
  [APP_DOWNLOAD_BUTTON_CLICKED]: 2,
  [APPRAISAL_REQUESTED]: 3,
  [APPRAISAL_SELECT_DEALER_CONFIRMED]: 2,
  [DETAIL_NAVBAR_CLICKED]: 1,
  [DETAIL_VIEWED]: 13,
  [FILTER_ADDED]: 2,
  [FILTERS_RESTART_CLICKED]: 2,
  [INSTANT_OFFER_FORM_VIEWED]: 2,
  [INSTANT_OFFER_NEXT_CONFIRMED]: 2,
  [LANDING_IO_DATE_CONFIRMED]: 4,
  [LANDING_IO_NEXT_CONFIRMED]: 2,
  [LANDING_IO_VIEWED]: 2,
  [LAST_DETAILS_SEEN]: 2,
  [LEAD_ENRICHED]: 2,
  [LEAD_ERROR]: 1,
  [LEAD_TRIGGERED]: 19,
  [LIST_VIEWED]: 11,
  [MAP_CLICKED]: 2,
  [LIST_NEWS_SAVED_CLICKED]: 2,
  [LIST_NEWS_SAVED_VIEWED]: 1,
  [NEWS_DETAIL_VIEWED]: 4,
  [PHONE_VIEWED]: 6,
  [RESERVATION_DRAWER_VIEWED]: 1,
  [RESERVATION_MORE_INFORMATION_CLICKED]: 3,
  [RESERVATION_PAYMENT_VIEWED]: 1,
  [RESERVATION_START_CLICKED]: 3,
  [RESERVATION_SUCCESS]: 2,
  [RECOMMENDED_ADS_FALLBACK]: 2,
  [SEND_MESSAGE_BUTTON_CLICKED]: 1,
  [SIGNED_IN_ERROR]: 3,
  [SIGNED_UP_ERROR]: 3,
  [WEBSITE_CLICKED]: 2,
  [HOME_IO_BUTTON_CLICKED]: 2
}

const defaultEventVersionsMapper = ({event}) => {
  return Object.keys(eventVersions).includes(event) ? eventVersions[event] : null
}

export default defaultEventVersionsMapper
